// extracted by mini-css-extract-plugin
module.exports = {"animation":"_2Zr-is","gif":"_3xGly6","video":"_1CegZm"};